import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Button } from '@redlink/components/molecules';

export const NavBarItem = memo(({ title, onPress, isWhite = false }) => {
  const { styles } = useStyle();

  return (
    <Button
      variant="transparent"
      style={styles.navigationText}
      {...{ title, onPress }}
      textStyle={isWhite && styles.whiteText}
    />
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  navigationText: {
    fontSize: 16,
    fontWeight: '500',
  },
  whiteText: {
    color: colors.white,
  },
}));
